import styled, { css } from "styled-components";
import { theme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import { ButtonLink } from "../../../../../../../common-deprecated/styles/v2/lexus/components/Button";
import { h5Style } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import * as MonthlyPrice from "../price/styles/MonthlyPrice";

export const Wrapper = styled.dl`
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    font-size: 1.8rem;
    line-height: 3rem;
`;

const CommonListItemStyle = css`
    margin: 0 !important;
    padding: 12px 0 !important;
    font-size: 1.4rem;
    line-height: 2.2rem;
    text-transform: none !important;
    color: ${theme.colors.midnight};
    border-top: 1px solid ${theme.colors.platinumLight};
    &:last-of-type {
        border-bottom: 1px solid ${theme.colors.platinumLight};
    }
`;

export const ListItemTerm = styled.dt.attrs(() => ({
    className: "t-milli-text",
}))<{ isBold?: boolean; hasTotalPrice?: boolean }>`
    ${CommonListItemStyle};
    width: 60%;
    font-family: ${({ isBold }) => (isBold ? theme.fonts.bold : theme.fonts.book)};
    text-align: start;
    word-break: break-word;

    ${({ isBold }) =>
        isBold
            ? css`
                  text-transform: uppercase !important;
                  ${h5Style};
              `
            : css`
                  font-family: ${theme.fonts.book};
              `};

    ${({ hasTotalPrice }) =>
        hasTotalPrice &&
        css`
            flex-basis: 100% !important;
            width: 100% !important;
        `};
`;

export const ListItemValue = styled.dd.attrs(() => ({
    className: "t-milli-headline",
}))<{ isBold?: boolean; hasTotalPrice?: boolean }>`
    ${CommonListItemStyle};
    width: 40%;
    text-align: end;

    ${({ isBold }) =>
        isBold
            ? css`
                  ${h5Style};
              `
            : css`
                  font-family: ${theme.fonts.book};
              `};

    ${({ hasTotalPrice }) =>
        hasTotalPrice &&
        css`
            flex-basis: 100% !important;
            width: 100% !important;
            text-align: right !important;
            border-top: 0 !important;
        `};

    ${MonthlyPrice.MonthlyRateItem}
    ${MonthlyPrice.Text} {
        width: 100%;
    }
`;

export const RegularText = styled.span``;

export const MonthlyRateDisclaimer = styled.div`
    ${ButtonLink} {
        white-space: pre-wrap;
        > * {
            white-space: pre-wrap;
        }
    }
`;

export const DisclaimerWrapper = styled.div`
    font-family: ${theme.fonts.book};
    font-size: 1.2rem;
    line-height: 1.8rem;
`;
